import { GetterTree } from 'vuex';
import {
  EContentLibraryGetter,
  state as defaultState,
} from '@/content-library/store/content-library.constants';
import { IContentLibraryState } from '@/content-library/store/content-library.types';
import { RootState } from '@/store/store';

export const getters: GetterTree<IContentLibraryState, RootState> = {
  [EContentLibraryGetter.AllResourcesLoaded]: (state: IContentLibraryState): boolean => {
    return state.loaded && state.resources.length >= state.totalCount;
  },
  [EContentLibraryGetter.FilterActive](state: IContentLibraryState): boolean {
    return JSON.stringify(state.payload.filter) !== JSON.stringify(defaultState.payload.filter);
  },
};
